const PHONE_NUMBER_PATTERN = /^\([0-9]{3}\) [0-9]{3} [0-9]{4}$/;

export default function invalidPhone(phn) {
    if (!phn || phn.trim() === '') return false;
    return !PHONE_NUMBER_PATTERN.test(phn);
}
